<template>
  <div class="footer__subscribe footer-subscribe">
    <div class="container">
      <a-form-model
        v-if="!message"
        ref="form"
        class="footer__subscribe-grid"
        :model="formRequest"
        :rules="rules"
        @submit.prevent="submitHandler"
      >
        <h3 class="footer-subscribe__title">
          Новости Selectel:
        </h3>

        <a-form-model-item
          ref="email"
          class="footer__subscribe-input-container"
          prop="email"
        >
          <a-input
            v-model="formRequest.email"
            class="ant-input--inverse"
            :disabled="isDisabledForm"
            placeholder="Ваш email"
          ></a-input>
        </a-form-model-item>

        <a-form-model-item
          ref="isAgree"
          class="footer__subscribe-checkbox-container"
          prop="isAgree"
        >
          <a-checkbox
            v-model="formRequest.isAgree"
            class="footer__checkbox ant-checkbox--inverse"
            :disabled="isDisabledForm"
          >
            Оставляя почту, вы даете Согласие на обработку персональных данных на&nbsp;условиях
            <nuxt-link :to="localePath('/about/documents/personal-data/')">
              Политики
            </nuxt-link>
            .
          </a-checkbox>
        </a-form-model-item>

        <button
          class="btn btn--outline-inverse footer__subscribe-btn"
          :disabled="isDisabledForm"
          @click.prevent="submitHandler"
        >
          Подписаться
        </button>
      </a-form-model>
      <p
        v-else
        v-html="message"
      ></p>
    </div>
  </div>
</template>

<script>
import RestClient from '~/rest-client'

const restClient = new RestClient()

export default {
  name: 'FooterSubscribeForm',
  data() {
    return {
      rules: {
        email: [
          {
            type: 'email',
            message: 'Введите корректный e-mail',
            trigger: 'blur'
          },
          {
            required: true,
            message: 'Введите e-mail',
            trigger: 'blur'
          }
        ],
        isAgree: [
          {
            type: 'enum',
            enum: [true],
            required: true,
            message: 'Подтвердите согласие на обработку персональных данных',
            trigger: 'change'
          }
        ]
      },
      formRequest: {
        email: null,
        isAgree: null
      },
      isDisabledForm: false,
      message: null
    }
  },
  methods: {
    async submitHandler() {
      await this.$refs.form.validate(async isValidForm => {
        if (!isValidForm) return false

        this.isDisabledForm = true

        await restClient.proxy.esputnik.post(this.formRequest)
          .then(() => {
            this.message = 'Благодарим за подписку!'
          })
          .catch(() => {
            this.message = 'Ошибка соединения. <br> Попробуйте повторить запрос позже.'
          })
      })
    }
  }
}
</script>

<style lang="scss">
.footer-subscribe {
  padding: 24px 0 60px;
  border-bottom: 1px solid rgba(#FFF, 0.1);

  @media (max-width: $breakpoint-xxl + 1) {
    padding-bottom: 43px;
  }

  @media (max-width: 1150px) {
    padding-bottom: 25px;
  }

  @media (max-width: $breakpoint-lg) {
    padding-bottom: 27px;
  }

  @media (max-width: $breakpoint-md) {
    padding-bottom: 24px;
    border-bottom: none;
  }

  @media (max-width: $breakpoint-sm) {
    padding-top: 21px;
  }
}

.footer__subscribe-grid {
  display: grid;
  grid-template-columns: 3fr 4fr 2fr 3fr;
  grid-gap: 12px;

  @media (max-width: $breakpoint-xl + 1) {
    grid-template-columns: 1fr 2fr 1fr 1fr;
    grid-gap: 17px;
  }

  @media (max-width: 1150px) {
    grid-template-columns: 1fr 2fr 1fr;
    grid-gap: 0 11px;
  }

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: 2fr 1fr;
    grid-gap: 15px 13px;
  }

  @media (max-width: $breakpoint-md) {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
}

.footer-subscribe__title {
  margin-bottom: 0;
  margin-top: 7px;
  color: #FFF;

  @media (max-width: $breakpoint-xxl + 1) {
    margin-top: 0;
  }

  @media (max-width: 1150px) {
    margin-top: 5px;
  }

  @media (max-width: $breakpoint-lg) {
    margin-top: 0;
    grid-column: 1/3;
  }

  @media (max-width: $breakpoint-md) {
    margin-bottom: 15px;
    grid-column: auto;
  }
}

.footer__subscribe-input-container {
  position: relative;
  margin-bottom: 0;

  @media (max-width: $breakpoint-md) {
    margin-bottom: 16px;
  }

  .ant-form-explain {
    position: absolute;

    @media (max-width: $breakpoint-xl) {
      position: relative;
    }
  }
}

.footer__subscribe-checkbox-container {
  position: relative;
  max-width: 330px;
  margin-bottom: 0;
  padding-left: 5px;

  @media (max-width: 1150px) {
    grid-row: 2/3;
    grid-column: 2/3;
    margin-top: 14px;
    padding-left: 0;
  }

  @media (max-width: $breakpoint-lg) {
    grid-row: 3/4;
    grid-column: 1/3;
    margin-top: 0;
  }

  @media (max-width: $breakpoint-md) {
    margin-bottom: 16px;
    grid-row: auto;
    grid-column: auto;
  }

  .ant-form-explain {
    position: absolute;
    margin-top: 4px;
    padding-left: 24px;
    font-size: 10px;

    @media (max-width: 1250px) and (min-width: 1200px) {
      width: 105%;
    }

    @media (max-width: $breakpoint-md) {
      padding-left: 22px;
      position: relative;
    }
  }

  .ant-form-item-with-help {
    margin-bottom: 0;
  }
}

.footer__checkbox {

  span {
    font-size: 12px;
    line-height: 16px;

    @media (max-width: $breakpoint-xxl + 1) {
      font-size: 10px;
    }

    @media (max-width: 1150px) {
      font-size: 12px;
    }
  }
}

.footer__subscribe-btn {
  width: 52%;
  align-self: start;

  @media (max-width: $breakpoint-xl + 1) {
    width: 82%;
  }

  @media (max-width: 1150px) {
    margin-left: 6px;
    width: 75%;
  }

  @media (max-width: $breakpoint-lg) {
    margin-left: 0;
    width: 72%;
  }

  @media (max-width: $breakpoint-md) {
    margin-top: 10px;
    width: 100%;
  }
}
</style>